import micromodal from 'micromodal'
import YouTubeController from './YouTubeController.js'
class Modal {
  constructor() {
    this.youTube = null;
    this.youTubeController = null;
    this.#init();
  }
  #init() {
    micromodal.init({
      onShow: (targetModal, openTrigger) => {
        this.youTube = targetModal.querySelector('.youtube iframe');
        this.youTubeController = this.youTube && new YouTubeController(this.youTube);
        const thisModal = this;
        if (this.youTube && openTrigger.dataset.youtubevideoid) {
          this.youTube.addEventListener('load', onLoadPlay);
          function onLoadPlay() {
            thisModal.youTubeController.play();
            thisModal.youTube.removeEventListener('load', onLoadPlay);
          }
          this.youTube.src = `https://www.youtube.com/embed/${openTrigger.dataset.youtubevideoid}?enablejsapi=1`;
        } else {
          this.youTube && this.youTubeController.play();
        }
      },
      onClose: (targetModal) => {
        this.youTube && this.youTubeController.pause();
        this.youTubeController = null;
        (targetModal.id == 'modal-youtube') && (this.youTube.src = '');
      },
      disableScroll: true,
      awaitCloseAnimation: true,
    });
  }
}
export default Modal;